import { useRouter as useHelpersRouter } from '@hooks/useRouter';

export function useRouter() {
  return useHelpersRouter();
}

export default useRouter;
